import {
  Box,
  Divider,
  Text,
  HStack,
  Image,
  useBreakpointValue,
  VStack,
  Input,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import Poem2025 from "./poem2025";

function NewYear2025() {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isDesktop = useBreakpointValue({ base: false, md: true });
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const correctPassword = process.env.REACT_APP_PASSWORD2; // Replace with the actual password

  const handlePasswordSubmit = () => {
    if (password === correctPassword) {
      setAuthenticated(true);
    } else {
      alert(correctPassword);
    }
  };

  if (!authenticated) {
    return (
      <Box
        maxW="100%"
        overflow="hidden"
        minH="100vh"
        bgPos="center"
        bgAttachment="fixed"
        bgRepeat="no-repeat"
        bgSize="cover"
        bgColor="#ffb6c1"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Text fontSize="lg" textAlign="center" mb="4">
          Please enter the password!
        </Text>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          width="300px"
          mb="4"
        />
        <Button onClick={handlePasswordSubmit}>Submit</Button>
      </Box>
    );
  }

  if (isDesktop) {
    return (
      <Box
        maxW="100%"
        overflow="hidden"
        minH="100vh"
        bgPos="center"
        bgAttachment="fixed"
        bgRepeat="no-repeat"
        bgSize="cover"
        bgColor="#ffdbe0"
      >
        <HStack w="100%" justify="right">
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/bagel.jpg"
            padding="2px"
            w="5%"
          />
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/sidney.jpg"
            padding="2px"
            w="5%"
          />
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/bunny.jpg"
            padding="2px"
            w="5%"
          />
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/coit.jpg"
            padding="2px"
            w="5%"
          />
          <Text w="100%" fontSize="lg" textAlign="center">
            Happy New Year My Shonupie
          </Text>
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/cat.jpg"
            padding="2px"
            w="5%"
          />
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/cake.jpg"
            padding="2px"
            w="5%"
          />
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/hat.jpg"
            padding="2px"
            w="5%"
          />{" "}
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/rat.jpg"
            padding="2px"
            w="5%"
          />
        </HStack>

        <Text ml="5%" w="100%" fontSize="lg" textAlign="left"></Text>
        <Poem2025 />
        <Divider
          borderColor="black"
          borderWidth="2px"
          justifyContent="center"
          alignContent="center"
          mt="2%"
          mb="2%"
          ml="20%"
          w="60%"
        />
        <Text w="100%" textAlign="center" p="1%">
          Designed by Divij Garg.
        </Text>
      </Box>
    );
  } else if (isMobile) {
    return (
      <Box
        maxW="100%"
        overflow="hidden"
        minH="100vh"
        bgPos="center"
        bgAttachment="fixed"
        bgRepeat="no-repeat"
        bgSize="cover"
        bgColor="#ffdbe0"
      >
        <VStack w="100%" justify="center">
          <Image
            objectFit="cover"
            borderColor="white"
            src="Images/sidney.jpg"
            padding="2px"
            w="50%"
          />
        </VStack>
        <Text w="100%" fontSize="lg" textAlign="center">
          Happy New Year My Shonupie
        </Text>
        <Text ml="5%" w="100%" fontSize="lg" textAlign="left"></Text>
        <Poem2025 />
        <Divider
          borderColor="black"
          borderWidth="2px"
          justifyContent="center"
          alignContent="center"
          mt="2%"
          mb="2%"
          ml="20%"
          w="60%"
        />
        <Text w="100%" textAlign="center" p="1%">
          Designed by Divij Garg.
        </Text>
      </Box>
    );
  }

  return null;
}

export default NewYear2025;
